import React from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Button, FormGroup, FormControl } from 'react-bootstrap'
import { inject, observer } from "mobx-react"
import FaIcon from '../../../helpers/fa_icon.js'
import SpotifyEmbeddedPlaylistPreview from './SpotifyEmbeddedPlaylistPreview'
import SpotifyStaticPlaylistPreview from './SpotifyStaticPlaylistPreview'

@inject("store")
@observer
export default class SpotifyPlaylist extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      value: props.store.valueFor(this.props.field.uuid, "spotify", this.props.instance || 0),
      playlistName: null,
      songs: [],
      loading: false,
      error: false
    }

    props.store.registerLoadableComponent()
  }

  handleSaveModal = () => {
    const { store } = this.props
    this.setState({showModal: false})
    store.setValueFor(this.props.field.uuid, "spotify", this.props.instance || 0, this.state.value)
    store.persistFormContent()
  }

  handleShowModal = (e) => {
    e.preventDefault()
    this.setState({showModal: true})
  }

  renderSpotifyLink() {
    const { store } = this.props
    const { value, loading, error, playlistName } = this.state

    if(loading) {
      return (
        <FaIcon icon="spinner" spin text="Loading Spotify Playlist..." />
      )
    }
    else if(error) {
      const url = store.valueFor(this.props.field.uuid, "spotify", this.props.instance || 0)
      return (
        <FaIcon icon="exclamation-circle" text={`Unable to load: ${url}.  Please try again.`} />
      )
    }
    else if(playlistName) {
      return (
        <FaIcon icon="spotify" text={playlistName} />
      )
    }
    else {
      return (
        <FaIcon icon="spotify" text={this.props.field.label} />
      )
    }
  }

  renderPlaylist() {
    const { instance, store } = this.props
    const url = store.valueFor(this.props.field.uuid, "spotify", instance || 0)
    const { printVersion, playlists } = store

    if(printVersion) {
      return (
        <SpotifyStaticPlaylistPreview
          url={url}
          playlists={playlists}
        />
      )
    }
    else {
      return (
        <SpotifyEmbeddedPlaylistPreview
          url={url}
        />
      )
    }
  }

  render() {
    const { field, store } = this.props
    const { placeholder, uuid } = field
    let instance = this.props.instance || 0

    const { showModal, value } = this.state

    return (
      <div className="outer-form-container">
        <FormGroup>
          <div className="d-flex flex-row justify-content-between">
            <Form.Label onClick={this.handleShowModal} style={styles.link}>
              { this.renderSpotifyLink() }
            </Form.Label>
            { (!showModal && value) ?
              <div>
                <a href={value} target="_blank">Show on Spotify</a>
                { " | " }
                <a href="#" onClick={this.handleShowModal}>Change Playlist</a>
              </div>
              : 
              <div>
                <a href="#" onClick={this.handleShowModal}>Set Playlist</a>
              </div>
            }
          </div>
        </FormGroup>
        { this.renderPlaylist() }
        <Modal show={showModal} onHide={() => this.setState({showModal: false})}>
          <Modal.Header closeButton>
            <Modal.Title>
              <FaIcon icon="spotify" text="Spotify Playlist" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <FormControl
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={e => this.setState({value: e.target.value})}
                disabled={!store.editable}
              />
              <Form.Text>To get a link to your Spotify playlist choose "Share" and then "Copy Spotify Link". Any changes you make to your Spotify playlist in the future will automatically be reflected here.</Form.Text>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" className="w-100" onClick={this.handleSaveModal}>Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const styles = {
  link: {
    cursor: 'pointer'
  },
  audio: {
    maxWidth: "100%"
  }
}
